import type { IconData } from '@stacksjs/iconify-core'

export const bitcoinCircle1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path d=\"M24 8c8.837 0 16 7.163 16 16s-7.163 16-16 16S8 32.837 8 24S15.163 8 24 8\"/><path d=\"M19 17.018c.71 0 3.634-.017 5.985-.018c1.845 0 3.708.895 3.961 2.722a5.6 5.6 0 0 1-.013 1.624c-.273 1.773-2.066 2.655-3.86 2.654c-2.367-.001-5.319-.038-6.073-.038m0 .056c.945 0 5.152-.02 8.072-.018c1.669.002 3.384.716 3.784 2.337c.088.357.144.745.144 1.153c0 .435-.063.846-.162 1.223c-.411 1.574-2.068 2.282-3.695 2.286c-2.936.008-7.144-.036-8.143-.036M19 17v13.975M21.5 14v2.5M26 14v2.5m-4.5 15V34m4.5-2.5V34\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bitcoinCircle1
